'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/path.js
// module id = 20
// module chunks = 13